import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';

const IcepackStateCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'author') {
		return (
			<span className="icepack-state-custom-modal-cell__author">
				<b>{rowData.value.name}</b>
				<small>
					<i>{rowData.value.role}</i>
				</small>
			</span>
		);
	}

	return rowData.value || '-';
};

IcepackStateCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { IcepackStateCustomModalCell };
